import React from 'react';
import { X } from 'lucide-react';
import TimePicker from '../../ui/TimePicker';

interface TimeRangeInputProps {
  startMin: number;
  endMin: number;
  onChange: (startMin: number, endMin: number) => void;
  onRemove?: () => void;
}

const TimeRangeInput: React.FC<TimeRangeInputProps> = ({
  startMin,
  endMin,
  onChange,
  onRemove,
}) => {
  const handleStartChange = (newStart: number) => {
    const newEnd = Math.max(endMin, newStart + 15);
    onChange(newStart, newEnd);
  };

  const handleEndChange = (newEnd: number) => {
    if (newEnd > startMin) {
      onChange(startMin, newEnd);
    }
  };

  return (
    <div className="inline-flex items-center gap-1.5">
      <div className="inline-flex items-center gap-1.5 bg-gray-50 rounded-lg px-1 py-0.5">
        <TimePicker
          value={startMin}
          onChange={handleStartChange}
          max={1425}
          aria-label="Start time"
          className="flex items-center gap-1 px-2 py-1.5 bg-white border border-gray-200 rounded-md text-sm font-medium tabular-nums focus:outline-none focus:ring-2 focus:ring-purple-500/40 focus:border-purple-400"
        />
        <span className="text-gray-300 text-xs">&ndash;</span>
        <TimePicker
          value={endMin}
          onChange={handleEndChange}
          min={startMin + 15}
          aria-label="End time"
          className="flex items-center gap-1 px-2 py-1.5 bg-white border border-gray-200 rounded-md text-sm font-medium tabular-nums focus:outline-none focus:ring-2 focus:ring-purple-500/40 focus:border-purple-400"
        />
      </div>

      {onRemove && (
        <button
          onClick={onRemove}
          className="p-1 text-gray-300 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
          title="Remove time range"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
};

export default TimeRangeInput;
